// js-sdk库初始化存储空间

'use strict';

// 初始化sui方法空间

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sui = {
    native: {
        apiList: {},
        exportApi: {}, // 注册方法库
        suiStatus: {
            state: 0, // 用于标记当前可用状态
            detail: '' // 用于记录状态详情。
        },
        account: 0,
        debugMode: false,
        waitingConf: {
            _completes: [], // 用于存放页面初始化时需要执行的方法。再载入完接口列表后依次执行。
            complete: function complete() {
                for (var i = 0, j = sui.native.waitingConf._completes.length; i < j; i++) {
                    sui.native.waitingConf._completes[i]();
                }
                sui.native.waitingConf._completes = [];
            }
        }
    }
};

exports.default = sui;